import { useNavigate, useParams } from "react-router-dom";
import { Page } from "../components/page";
import translate from "../locales";
import { useState, useEffect } from "react";
import { fetchResult } from "../collector";
import { MultiPoster } from "../components/multi-poster";

export function DashboardStart() {
  const [groupCode, setGroupCode] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!groupCode) return;
    navigate(`/dashboard/${groupCode}`);
  };

  return (
    <Page className="page--background" logoType="colored">
      <title>{translate("dashboard.start.pageTitle")}</title>
      <main className="card">
        <form className="card__content" onSubmit={handleSubmit}>
          <div className="card__header">
            <h1 className="card__title card__title--small" id="dashboardTitle">
              {translate("dashboard.start.title")}
            </h1>
            <p
              className="card__subtitle card__subtitle--small"
              id="dashboardSubtitle"
            >
              {translate("dashboard.start.subtitle")}
            </p>
          </div>
          <div className="input card__input">
            <input
              autoFocus
              className="input__field"
              id="groupCodeInput"
              type="text"
              placeholder={translate("dashboard.start.placeholder")}
              value={groupCode}
              onChange={(e) => setGroupCode(e.target.value)}
              maxLength={25}
              aria-labelledby="dashboardTitle"
              aria-describedby="dashboardSubtitle"
            />
            <span className="input__helper">
              {translate("exercise.ui.text-input-footer", {
                count: groupCode.length,
                limit: 25,
              })}
            </span>
          </div>
          <button className="card__button button" type="submit">
            {translate("dashboard.start.submit")}
          </button>
        </form>
      </main>
    </Page>
  );
}

export function Dashboard() {
  const { code } = useParams();
  const [results, setResults] = useState(null);

  async function getResults() {
    const result = await fetchResult(code);
    setResults(result);
  }

  useEffect(() => {
    getResults();
  }, [code]);

  return (
    <Page logoType="colored">
      <title>
        {translate("dashboard.group.pageTitle", { groupCode: code })}
      </title>
      <main className="page__container">
        <div className="dashboard-header">
          <h1 className="dashboard-header__title">
            {translate("dashboard.group.title")}
          </h1>
          <p className="dashboard-header__group">
            {translate("dashboard.group.groupCode", { groupCode: code })}
          </p>
        </div>
        <div className="dashboard-grid">
          {results?.map((r) => (
            <MultiPoster key={r.public_id} data={r.answers} allowHide={true} />
          ))}
        </div>
      </main>
    </Page>
  );
}
